<template>
  <div>
    <transition name="fade">
      <div :key="'delivery_time_dark'" class="pu_dark" v-show="$store.getters.modal.time"></div>
    </transition>
    <transition name="slide">
      <div :key="'delivery_time'" class="pu_bottom popup_click_hide" v-show="$store.getters.modal.time">
        <div class="pu_bottom_scroll">
          <div @click="close" class="pu_b_close"></div>
          <div class="pu_bottom_inner ">
            <div class="pu_select" style="display: block">
              <smooth-picker :change="dataChange" :data="data" :style="style" class="time_picker"
                             ref="smoothPicker"/>
            </div>
            <div class="pu_tovar_nav pu_tovar_nav_one">
              <div class="pu_tovar_nav_btn">
                <a @click="pick()" class="fbb_btn">
                  {{ buttonText }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import {SmoothPicker} from 'vue-smooth-picker'
  import 'vue-smooth-picker/dist/css/style.css'
  import * as moment from 'moment'
  import {mapGetters} from 'vuex'
  import {SET_DELIVERY_TIME_OBJECT, SET_MODAL, SET_TIMES} from '@/store/mutations.type'

  export default {
    name: 'DeliveryIntervalTime',
    components: {
      SmoothPicker
    },
    data() {
      return {
        backupState: {
          pickedDay: null,
          pickedTime: null
        },

        style: {display: 'block'},

        data: [
          {
            currentIndex: 0,
            flex: 2,
            list: [],
            textAlign: 'center',
            className: 'row-group'
          },
          {
            currentIndex: 0,
            flex: 3,
            list: [],
            textAlign: 'center',
            className: 'item-group'
          }
        ],

        dayList: [],
        timeList: [],

        pickedDay: null,
        pickedTime: null
      }
    },
    watch: {
      pickedDay: function (pickedDay) {

        this.timeList = []

        let key = null
        let date = null
        if (pickedDay.data === moment().utcOffset(this.$store.getters.outletSettings.timezone_offset).add(this.$store.getters.outletSettings.accept_day_shift, 'd').date()) {
          key = 'today'
          date = moment().utcOffset(this.$store.getters.outletSettings.timezone_offset).add(this.$store.getters.outletSettings.accept_day_shift, 'd')
        }
        if (pickedDay.data === moment().utcOffset(this.$store.getters.outletSettings.timezone_offset).add(this.$store.getters.outletSettings.accept_day_shift, 'd').add(1, 'd').date()) {
          key = 'tomorrow'
          date = moment().utcOffset(this.$store.getters.outletSettings.timezone_offset).add(this.$store.getters.outletSettings.accept_day_shift, 'd').add(1, 'd')
        }

        let offset = date.utcOffset()

        this.timeList = this.timeList.concat(
          this.$store.getters.outletSettings.delivery_time[key].map((el) => {

            let data = el

            return {value: el, data: data, label: el}
          })
        )

      },

      dayList: function (dayList) {
        if (this.backupState.pickedDay) {
          for (let i in dayList) {
            if (this.pickedDay.value === dayList[i].value) {
              this.pickedDay = dayList[i]
              this.$refs.smoothPicker.setGroupData(0, Object.assign({}, this.data[0], {
                list: dayList,
                currentIndex: Number(i)
              }))
              this.backupState.pickedDay = null
              return
            }
          }
          this.backupState.pickedDay = null
        }

        this.$refs.smoothPicker.setGroupData(0, Object.assign({}, this.data[0], {list: dayList}))
        this.pickedDay = dayList[0]
      },

      timeList: function (timeList) {
        if (this.backupState.pickedTime) {
          for (let i in timeList) {
            if (this.pickedTime.value === timeList[i].value) {
              this.pickedTime = timeList[i]
              this.$refs.smoothPicker.setGroupData(1, Object.assign({}, this.data[1], {
                list: timeList,
                currentIndex: Number(i)
              }))
              this.backupState.pickedTime = null
              if (this.$store.getters.outletSettings.accept_today === true) {
                this.updateStore({})
              }
              return
            }
          }
          this.backupState.pickedTime = null
        }

        if (this.pickedTime && this.pickedTime.value) {
          for (let i in timeList) {
            if (this.pickedTime.value === timeList[i].value) {
              this.pickedTime = timeList[i]
              this.$refs.smoothPicker.setGroupData(1, Object.assign({}, this.data[1], {
                list: timeList,
                currentIndex: Number(i)
              }))
              if (this.$store.getters.outletSettings.accept_today === true) {
                this.updateStore({})
              }
              return
            }
          }
        }

        this.$refs.smoothPicker.setGroupData(1, Object.assign({}, this.data[1], {list: timeList}))
        this.pickedTime = timeList[0]
        if (this.$store.getters.outletSettings.accept_today === true) {
          this.updateStore({})
        }
      }

    },

    computed: {
      buttonText() {
        if (!this.pickedTime || !this.pickedDay) {
          return ''
        }

        if (this.pickedTime.data === null && this.$store.getters.outletSettings.accept_today === true && this.$store.getters.outletSettings.delivery_time.forbidAsFastAsYouCan === false) {
          return this.text('screen_form_as_fast_as_you_can')
        }

        return this.pickedDay.value + ' ' + this.text('screen_form_at_time', {'time': this.pickedTime.value})

      },
      ...mapGetters(['language'])
    },

    mounted() {

      this.setPickerData()

      this.updateStore({ifEmpty: true})

      this.$store.subscribe(mutation => {
        if (mutation.type === SET_MODAL && mutation.payload.modal === 'time') {
          if (mutation.payload.status === true) {
            this.style.display = 'flex' // костыль для smooth-picker
          }
        }
        if (mutation.type === SET_TIMES) {
          this.setPickerData()
        }
      })
    },

    methods: {
      setPickerData() {
        this.dayList = []

        this.backupState.pickedDay = this.pickedDay
        this.backupState.pickedTime = this.pickedTime

        if (this.$store.getters.outletSettings.accept_today === true) {

          if (this.$store.getters.outletSettings.delivery_time.today.length !== 0) {
            this.dayList.push({
              value: this.text('screen_form_today'),
              data: moment().utcOffset(this.$store.getters.outletSettings.timezone_offset).date()
            })
          }
          if (this.$store.getters.outletSettings.delivery_time.tomorrow.length !== 0) {
            this.dayList.push({
              value: this.text('screen_form_tomorrow'),
              data: moment().utcOffset(this.$store.getters.outletSettings.timezone_offset).add(1, 'd').date()
            })
          }

          this.pickedDay = this.dayList[0]

        } else {

          let date = moment().utcOffset(this.$store.getters.outletSettings.timezone_offset).locale(this.language)
          date.add(this.$store.getters.outletSettings.accept_day_shift, 'd')

          if (moment().utcOffset(this.$store.getters.outletSettings.timezone_offset).hour() === 23 || (moment().utcOffset(this.$store.getters.outletSettings.timezone_offset).hour() === 22 && moment().utcOffset(this.$store.getters.outletSettings.timezone_offset).minutes() >= 30)) {
            date.add(1, 'd')
          }

          let label = null
          if (this.$store.getters.outletSettings.delivery_time.today.length !== 0) {
            label = this.$options.filters.capitalize(date.format('MMMM')) + ' ' + date.date() + ' (' + date.format('dd') + ')'
            this.dayList.push({value: label, data: date.date()})
          }

          date.add(1, 'd')

          if (this.$store.getters.outletSettings.delivery_time.tomorrow.length !== 0) {
            label = this.$options.filters.capitalize(date.format('MMMM')) + ' ' + date.date() + ' (' + date.format('dd') + ')'
            this.dayList.push({value: label, data: date.date()})
          }

        }
      },

      updateStore({ifEmpty = false}) {
        if (this.$store.getters.deliveryTimeMode !== this.$store.getters.DELIVERY_TIME && 
            this.$store.getters.deliveryTimeMode !== this.$store.getters.DELIVERY_ONE_DAY) {
          return
        }
        if (ifEmpty === true) {
          if (this.$store.getters.deliveryTimeObject.time.data !== null ||
            this.$store.getters.deliveryTimeObject.day.data !== null) {
            return
          }
        }
        this.$store.commit(SET_DELIVERY_TIME_OBJECT, {
          day: this.pickedDay,
          time: this.pickedTime,
          month: {value: null, data: null}
        })
      },

      pick() {
        this.updateStore({})
        this.close()
      },

      close() {
        this.$store.commit(SET_MODAL, {modal: 'time', status: false})
      },

      dataChange(group, itemIndex) {
        if (group === 0) {
          this.pickedDay = this.dayList[itemIndex]
        }
        if (group === 1) {
          this.pickedTime = this.timeList[itemIndex]
        }
      }
    }

  }
</script>
